import app from '@/app';

/* @ngInject */
function Resource($resource) {
  return $resource(
		'api/decisionTreeProjects',
		{ id: '@id' },
		{
			create: { method: 'POST' },
			query: { method: 'GET' },
			all: { method: 'GET', params: { id: 'all' }, isArray: true },
			update: { method: 'PUT' }
		}
	);
}

app.factory('DecisionTreeProject', Resource);
